<div class="multi-select-container">

  <!-- Tags dentro del input -->
  <div class="tag-input-wrapper" (click)="showDropdown = true">
    <div class="tag" *ngFor="let item of selected">
      {{ item }}
      <span class="remove" (click)="removeTag(item)">×</span>
    </div>

    <input type="text" [(ngModel)]="search" (input)="onSearchChange()" (keydown.enter)="handleEnter()"
      [placeholder]="'multiSelect.inputPlaceholder' | translate" (focus)="onFocus()" (blur)="addValue(this.search)" />
  </div>

  <!-- Dropdown -->
  <div class="dropdown" *ngIf="showDropdown && (search.trim() || filteredData.length > 0)">
    <div class="dropdown-item" *ngFor="let option of filteredData; let last = last" [class.lastItem]="last"
      (click)="addValue(option)">
      {{ option }}
    </div>
  </div>

</div>